module.exports = __webpack_public_path__ + "img/no-follow-empty.e119fef2.png";